import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppDispatch, useAuth, useIsDemoUser } from '@/hooks/redux';
import { openAuthModal } from '@/store/slices/uiSlice';
import { isGuestUser } from '@/utils';

/**
 * Account pages: guests and demo users are sent to the home page with the login popup open,
 * which brings them back here after logging in.
 */
export function ProtectedRoute() {
  const { isLoading } = useAuth();
  const isGuest = isGuestUser();
  const isDemoUser = useIsDemoUser();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const blocked = !isLoading && (isGuest || isDemoUser);

  useEffect(() => {
    if (blocked) {
      dispatch(
        openAuthModal({ view: 'login', returnTo: `${location.pathname}${location.search}` })
      );
    }
    // Only when the guard first blocks; the redirect below changes the location.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocked, dispatch]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (blocked) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
